import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { HeroImage } from "./HeroImage";
import HomeCards from "./HomeCards";
import { Eventbrite } from "./Eventbrite";
import { RouteMap } from "./RouteMap";
import { TempImageCarousel } from "./TempImageCarousel";
import EventbriteEmbeddedCheckout from "./EventbriteEmbeddedCheckout";

function Home() {
  const handleComplete = () => {
    console.log("Order completed!");
    // maybe redirect or show a thank-you message
  };
  return (
    <>
      <Container className="content">
        <HeroImage />
        <TempImageCarousel />
        <HomeCards />
        <RouteMap />
        {/* <Eventbrite /> */}
        {/* <EventbriteEmbeddedCheckout
          eventId="1761704017139"
          iframeHeight={500}
          onOrderComplete={handleComplete}
          modal={false}
        /> */}
      </Container>
    </>
  );
}

export { Home };
